import React from 'react'
import styles from "../styles/Home.module.scss";
import { isMobile } from 'react-device-detect';

const SplitSection = (props) => {
  const { 
    bottomHalfText, 
    bottomHalfHeader, 
    qrCode,
    topHalfText,
    bbBee,
    bbMascot
   } = props;

   const DesktopRender = () =>{ 
    return ( 
      <div className={styles.section} >

          <div className={styles.container}>
    
          <img className={styles.floatingImgLeft} src={bbBee} alt="explore" />
          <img className={styles.floatingImgRight} src={bbMascot} alt="explore" />
  
          <div className={styles.heroWrapper}>
            <div className={styles.fullDual}>
              <div className={styles.topHalf}>
                <img src={qrCode} alt="buildboxworld-qr-code"/>
                <p className={styles.topHalfText}>{topHalfText}</p>
              </div>
  
              <div className={styles.bottomHalf}>
                <h1 className={styles.bottomHalfHeader}>
                  {bottomHalfHeader}
                </h1>
                <p className={styles.bottomHalfText}>
                  {bottomHalfText}
                </p>
              </div>
            </div>
          </div>
        </div>     
      </div>
    )
   }

   const MobileRender = () => {
    return (
      <div className={styles.fullDual}>
        <div className={styles.bottomHalf}>
          <h1 className={styles.bottomHalfHeader}>
            {bottomHalfHeader}
          </h1>
          <p className={styles.bottomHalfText}>
            {bottomHalfText}
          </p>
      </div>
      </div>
    )
   }

  return (
    <>
     {!isMobile && <DesktopRender/> }
     { isMobile && <MobileRender />}
    </>
  )
}


export default SplitSection
